import { FileCheck } from 'lucide-react'

/**
 * Evidence citation — the auditable quote behind a number. No left rail: the
 * verified chip + a hairline-divided source line carry it.
 */
export function EvidenceCitation({
  quote,
  source,
  page,
  verified = true,
}: {
  quote: string
  source: string
  page?: string
  verified?: boolean
}) {
  return (
    <div className="rounded-md border bg-surface-2 p-4">
      <p className="text-[13.5px] leading-relaxed">{quote}</p>
      <div className="mt-2.5 flex items-center gap-2 border-t pt-2.5 text-xs text-muted-foreground">
        <FileCheck className="size-3.5 shrink-0" />
        <span className="min-w-0 truncate">
          {source}
          {page && ` · ${page}`}
        </span>
        {verified && (
          <span className="ml-auto shrink-0 rounded border border-input bg-surface px-1.5 py-0.5 text-[11px]">
            verified ✓
          </span>
        )}
      </div>
    </div>
  )
}
